// Then update your src/index.jsx to include the BrowserRouter:

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

// Custom error boundary component
class PointerLockErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // If this is a pointer lock error, suppress it
    if (error && error.message && error.message.includes('lock before this request was completed')) {
      return { hasError: false }; // Return false to continue rendering normally
    }
    return { hasError: true }; // For other errors, trigger the fallback UI
  }

  componentDidCatch(error, errorInfo) {
    if (error && error.message && error.message.includes('lock before this request was completed')) {
      console.log('Pointer lock error suppressed by boundary');
    } else {
      console.error('Error caught by boundary:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render a fallback UI or just return children
      return <h1>Something went wrong.</h1>;
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <PointerLockErrorBoundary>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </PointerLockErrorBoundary>
);